"use strict";
exports.__esModule = true;
var createColorStyles = function (theme) {
    var _a = theme.colors, primaryText = _a.primaryText, primary = _a.primary;
    return {
        primaryTextOnPrimary: {
            color: primaryText,
            background: primary
        }
    };
};
exports["default"] = createColorStyles;
//# sourceMappingURL=createColorStyles.js.map